import './App.css';
import LotusCrackersLanding from './LandingPage';

function App() {
  return (
    <div className="App">
      <LotusCrackersLanding />
    </div>
  );
}

export default App;
